// extracted by mini-css-extract-plugin
export default {"paymentSection":"p6-z","disabled":"q6-z"};